export const EVENT_OPERATOR_ROLES = [
  'admin',
  'cashier',
  'mobile_operator',
  'production',
  'delivery',
  'supervisor',
] as const

export type EventOperatorRole = (typeof EVENT_OPERATOR_ROLES)[number]

export const EVENT_OPERATOR_ROLE_LABELS: Record<EventOperatorRole, string> = {
  admin: 'Admin',
  cashier: 'Cassiere',
  mobile_operator: 'Operatore mobile',
  production: 'Produzione',
  delivery: 'Consegna',
  supervisor: 'Supervisore',
}

export const isEventOperatorRole = (value: string): value is EventOperatorRole =>
  EVENT_OPERATOR_ROLES.includes(value as EventOperatorRole)
